import { useState, useEffect, Dispatch, SetStateAction } from 'react';

export const useSessionStorage = <T>(
  key: string,
  initialValue?: T
): [T, Dispatch<SetStateAction<T>>, () => void] => {
  const storedValue = sessionStorage.getItem(key);
  const initial = storedValue ? JSON.parse(storedValue) : initialValue;

  // Create a state variable
  const [value, setValue] = useState<T>(initial);

  const removeItem = () => sessionStorage.removeItem(key);

  // Update sessionStorage when the state changes
  useEffect(() => {
    sessionStorage.setItem(key, JSON.stringify(value ?? ''));
  }, [key, value]);

  return [value, setValue, removeItem];
};
